module.exports = __webpack_public_path__ + "static/img/icon5.1af03eda.png";